import React, { useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter, Col, CardBody } from 'reactstrap';
import { Form, TextArea } from 'semantic-ui-react';
import Axios from 'axios';
import swal from "sweetalert";
import {Services} from '../../../../Services'

function AddComments(props) {
	// console.log('props en modaaal-->', props);
	const [openModal, setopenModal] = useState(false);
	const [buttonAdd, setButtonAdd] = useState(true);
	const [model, setModel] = useState({
		Comment: { value: '', type: 'text', hidden: false },
		RowId: { value: props.idContainer, type: 'text', hidden: false },
		UserId: { value: props._user, type: 'text', hidden: false },
	})

	function toggle() {
		setopenModal(!openModal);
	}

	function handleChange(evt, data,) {
		let ModelSend = { ...model };
		let id = data.id;
		let value = data.value;
		ModelSend[id].value = value;
		// console.log('ModelSend-->', ModelSend.Comment.value);
		setModel({ ...model })
		if (ModelSend.Comment.value) {
			if (ModelSend.Comment.value.trim() !== "") {
				setButtonAdd(false)
			}
			else {
				setButtonAdd(true)
			}
		}
		else {
			setButtonAdd(true)
		}
	}

	const CreateComment = () => {
		// setActiveLoader(false)

		Axios.post(`${Services.createComments.path}Comments/addcomments/`, model)
			.then((response) => {
				swal("Comment saved!", "Comment has been saved successfully!", "success");
				props.getComments()
				setButtonAdd(true)
				// console.log('response', response);
			})
			.catch((error) => {
				console.warn(error);
			});
	}

	return (
		<React.Fragment>
			<Col style={{ textAlignLast: 'right' }}>
				<CardBody>
					<Button
						color="primary"
						onClick={toggle}
					>
						<i className='fas fa-comments mr-2' />Add Comment
					</Button>
				</CardBody>
			</Col>
			<Modal
				isOpen={openModal}
			>
				<ModalBody>
					<CardBody style={{ textAlignLast: 'center' }}>
						<i
							style={{ fontSize: '7em', color: 'orange' }}
							className='fas fa-comment-dots'></i>
					</CardBody>
					<Form>
						<TextArea
							fluid
							id={'Comment'}
							placeholder={'write your comment'}
							onChange={(evt, data) => { handleChange(evt, data); }}
						/>
					</Form>
				</ModalBody>
				<ModalFooter style={{ justifyContent: 'center' }}>
					<Button
						disabled={buttonAdd}
						color="primary"
						className="btn-round"
						onClick={() => { CreateComment(); setopenModal(false) }}
					>
						<i className='fas fa-plus-circle mr-2' />Add</Button>{' '}
					<Button
						color="danger"
						onClick={() => { setopenModal(false); props.onCancel(); }}>
						<i className='fas fa-window-close mr-2' />Cancel</Button>
				</ModalFooter>
			</Modal>
		</React.Fragment>
	);
};


AddComments.defaultProps = {
	onCancel: () => { },
};

export default AddComments;